import axios from "axios";

//IMPORT API ROUTE URL
import { GET_AUTO_SUGGESSION_MAIN_LIST } from "./apiRoutes";

const getAutoSuggessionForMainSearch = (keyword) => {
  var postData = new FormData();

  postData.append("keyword", keyword);

  return axios
    .post(GET_AUTO_SUGGESSION_MAIN_LIST, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getAutoSuggessionForMainSearch;
